export const SITUATION_ACTION_ID = 'SituationChange';
